<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Add Persian Instrument Name</h5>
      <form [formGroup]="AddNewDevicepersian" (submit)="SubmitAddNewDevicepersian()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice)" class="btn btn-danger left"> Select Instrument  <i class="fa fa-cc-amex"></i> </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.title}}" />
          </div>
        </div>

        <div class="row" *ngIf="Data_Seleted_Record.id>0">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Persian Name</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the Persian name.</small>
          </div>
        </div>

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing && Data_Seleted_Record.id>0" type="submit" [disabled]="!AddNewDevicepersian.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button *ngIf="!InProccessing && Data_Seleted_Record.id>0" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
        <button routerLink="/Devicepersian" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>



<ng-template #templateDevice>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Instrument List  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> Instrument Name </label>
            <input  type="text" class="form-control" (keyup)="ReadData_Device_KeySearch()" [(ngModel)]="Search_Name_Device_Table"  placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device
            | paginate
                    : {
                        id: 'DataList_Device',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Device).length
                      }">
              <td>{{DataList_Device.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>

 </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">Close</button>
  </div>
</ng-template>
